import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';
import { ITableColumn } from '../../shared/table/table.component';
import { EmployeeApplicationConfigService } from '../../services/employee-application-config.service';
import { IEmployeeApplicationConfigListItem } from '../../models/EmployeeApplicationConfig';

@Component({
    selector: 'app-employee-application-config-list',
    templateUrl: './list.component.html'
})
export class EmployeeApplicationConfigListComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: EmployeeApplicationConfigService
    ) { }

    readonly columns: ITableColumn[] = [
        { property: 'Code', label: 'employeeApplicationConfig_lblCode', sorts: true },
        { property: 'Status', label: 'employeeApplicationConfig_lblStatus', sorts: true },
        { property: 'Version', label: 'employeeApplicationConfig_lblVersion', sorts: true, type: 'number' },
        { property: 'Name', label: 'employeeApplicationConfig_lblName' },
        { width: '1px' }
    ];

    items: IEmployeeApplicationConfigListItem[] = [];

    ngOnInit() {
        this.loadItems();
    }

    delete(item: IEmployeeApplicationConfigListItem) {
        this.app.confirm(this.app.translate('employeeApplicationConfig_deleteConfirm').replace('{name}', item.Name), result => {
            if (!result) return;

            this.app.addLoading(this.service.delete(item.Id)).subscribe(() => {
                this.loadItems();
            });
        });
    }

    canDelete(item: IEmployeeApplicationConfigListItem): boolean {
        return item.Status === 'Draft';
    }

    private loadItems() {
        this.app.addLoading(this.service.get()).subscribe(data => {
            this.items = data;
        });
    }
}
